export const ACCOUNT_STATUS = {
PENDING:
'pending',

ACTIVE:
'active',

BLOCKED:
'blocked',

SUSPENDED:
'suspended',

} as const;